import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import FooterVariant from './FooterVariant';
import FooterControl from './FooterControl';
import { useValidation } from '../utils';

const Footer = props => {
  const {
    spaseekers: {
      layout: {
        footer: {
          menu: { helpfulLinks, legalInformation },
          openingHours,
        },
      },
      site: { telephone },
    },
  } = useStaticQuery(graphql`
    query FooterQuery {
      spaseekers {
        layout {
          footer {
            menu {
              helpfulLinks {
                text
                url
              }
              legalInformation {
                text
                url
              }
            }
            openingHours {
              weekday
              saturday
              sunday
            }
          }
        }
        site {
          telephone
        }
      }
    }
  `);

  const testVariation = process.env.GATSBY_HOMEPAGE_TEST_VARIATION;

  const navLinks = [
    {
      heading: 'Helpful Links',
      links: helpfulLinks,
    },
    {
      heading: 'Legal Information',
      links: legalInformation,
    },
  ];

  const contactInformation = {
    youtubeProfile: 'https://www.youtube.com/user/spaseekers',
    twitterProfile: 'https://twitter.com/spaseekers',
    facebookProfile: 'https://www.facebook.com/spaseekers',
    instagramProfile: 'https://www.instagram.com/spaseekers',
  };

  // Validation
  const requiredFields = [
    { name: 'firstName', type: 'input' },
    { name: 'lastName', type: 'input' },
    { name: 'email', type: 'input' },
    { name: 'regionId', type: 'select' },
  ];

  useValidation(requiredFields);

  const formName = 'newsletter-form';

  const [selectedRegion, setSelectedRegion] = useState();

  return testVariation === 'variant' ? (
    <FooterVariant
      formName={formName}
      selectedRegion={selectedRegion}
      setSelectedRegion={setSelectedRegion}
      navLinks={navLinks}
      openingHours={openingHours}
      telephone={telephone}
      contactInformation={contactInformation}
      {...props}
    />
  ) : (
    <FooterControl
      formName={formName}
      selectedRegion={selectedRegion}
      setSelectedRegion={setSelectedRegion}
      navLinks={navLinks}
      openingHours={openingHours}
      telephone={telephone}
      contactInformation={contactInformation}
      {...props}
    />
  );
};

export default Footer;
